/* Responsibility: Utils for filter utilising checkboxes */

import dom from '../../lib/dom.js';
import fn from '../../lib/fn.js';
import { thousandSeparated } from '../../lib/formatting.js';

export default function (params) {
    return {
        contains(list, value) {
            return list && list.split(',').indexOf(value) >= 0;
        },

        isChecked(input) {
            return input.checked;
        },

        isUnchecked(input) {
            return !input.checked;
        },

        getValue(input) {
            return input.value;
        },

        checkbox(value) {
            const boxes = dom.byQuerySelector(`input[value='${value.replace(/'/g, "\\'")}']`, params.root);
            if (boxes.length) {
                return boxes[0];
            }
            return false;
        },

        entryCountFromName(entries, name) {
            const firstEntry = fn.first((entry) => entry.name === name, entries);
            return firstEntry ? firstEntry.count : 0;
        },

        checkboxes() {
            return dom.byQuerySelector("input[type='checkbox']", params.root);
        },

        checkedValues() {
            return fn.map(this.getValue, fn.remove(this.isUnchecked, this.checkboxes()));
        },

        eachCheckbox(func) {
            fn.forEach(this.checkboxes(), func);
        },

        eachCheckedCheckbox(func) {
            fn.forEach(fn.remove(this.isUnchecked, this.checkboxes()), func);
        },

        setState(checkbox, count) {
            const parent = dom.closestWithClass('input-toggle', checkbox);
            const element = dom.byQuerySelector('span', parent)[0];

            if (element && element.getAttribute('data-count') === '') {
                if (element.textContent) {
                    element.textContent = `(${thousandSeparated(count)})`;
                } else {
                    element.innerText = `(${thousandSeparated(count)})`;
                }

                if ((count !== '0' && count) || checkbox.checked) {
                    this.enable(parent, checkbox);
                } else {
                    this.disable(parent, checkbox);
                }
            }
        },

        disable(parent, box) {
            dom.addClass('opacity50', parent);
            box.disabled = true;
            box.checked = false;
        },

        enable(parent, box) {
            dom.removeClass('opacity50', parent);
            box.disabled = false;
        },

        updateResultViewCriteria(resultViewCriteria, key, filterFn) {
            const resolveValues = () => {
                const inputs = this.checkboxes();
                if (fn.every(this.isUnchecked, inputs)) {
                    return [];
                }
                return fn.map(this.getValue, fn.remove(filterFn, inputs));
            };
            resultViewCriteria[key] = resolveValues();
        },

        setStateFromUrlParams(filterAddedCallback, filterRemovedCallback, modifiedCompleteCallback) {
            let modified = false;
            const queries = params.urlQueryParams[params.urlKey];
            if (queries) {
                fn.forEach(queries, (query) => {
                    const box = this.checkbox(query);
                    if (box) {
                        box.checked = true;
                        filterAddedCallback(box);
                        modified = true;
                    }
                });
            }
            this.eachCheckedCheckbox((box) => {
                if (!queries || fn.indexOf(box.value, queries) === -1) {
                    box.checked = false;
                    if (filterRemovedCallback) {
                        filterRemovedCallback(box.value);
                    }
                    modified = true;
                }
            });
            if (modified && modifiedCompleteCallback) {
                modifiedCompleteCallback();
            }
        },

        flattenFacetsLists(facets) {
            if (facets === null) {
                return [];
            }
            if (fn.isList(facets)) {
                return facets;
            }
            return fn.flatten(fn.values(facets));
        },
    };
}
